var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebAppDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0876 0.742188H3.92428C2.23503 0.742188 0.832642 2.11271 0.832642 3.80195V24.9016C0.832642 26.5908 2.20316 27.9613 3.92428 27.9613H17.0876C18.7769 27.9613 20.1793 26.5908 20.1793 24.9016V3.80195C20.1793 2.11271 18.8087 0.742188 17.0876 0.742188ZM19.2231 24.9016C19.2231 26.0808 18.2669 27.0051 17.0876 27.0051H3.92428C2.74499 27.0051 1.78882 26.049 1.78882 24.9016V3.80195C1.78882 2.62267 2.74499 1.69836 3.92428 1.69836H17.0876C18.2669 1.69836 19.2231 2.65454 19.2231 3.80195V24.9016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4104 3.76953H6.53784C6.28286 3.76953 6.05975 3.99264 6.05975 4.24762C6.05975 4.5026 6.28286 4.72571 6.53784 4.72571H14.4104C14.6653 4.72571 14.8884 4.5026 14.8884 4.24762C14.8884 3.99264 14.6653 3.76953 14.4104 3.76953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 22.0312C9.59756 22.0312 8.89636 22.7643 8.89636 23.6249C8.89636 24.0392 9.05572 24.4536 9.37445 24.7404C9.6613 25.0273 10.0756 25.1866 10.49 25.1866C11.3824 25.1866 12.0836 24.4536 12.0836 23.593C12.0836 22.7324 11.3824 22.0312 10.49 22.0312ZM10.5219 24.2623C10.3625 24.2623 10.2031 24.1986 10.0756 24.0711C9.94816 23.9436 9.88441 23.7842 9.88441 23.6249C9.88441 23.2743 10.1713 22.9874 10.5219 22.9874C10.8725 22.9874 11.1593 23.2743 11.1593 23.6249C11.1593 23.9755 10.8725 24.2623 10.5219 24.2623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAppDevelopmentIcon);
export default __webpack_public_path__ + "static/media/webAppDevelopmentIcon.742b1557d3dafde521025d21c625a44f.svg";
export { ForwardRef as ReactComponent };